import { render } from "./MembersList.vue?vue&type=template&id=a4f108ba&scoped=true"
import script from "./MembersList.vue?vue&type=script&lang=js"
export * from "./MembersList.vue?vue&type=script&lang=js"

import "./MembersList.vue?vue&type=style&index=0&id=a4f108ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4f108ba"]])

export default __exports__